<template>
  <div class="maintenance-wrapper bg-light min-vh-100 font-inter page-wrapper">
    
    <div class="container-fluid py-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 class="font-weight-bold text-dark mb-0">
            <i class="fa fa-wrench text-primary mr-2"></i>Quản lý Bảo dưỡng & Sửa chữa
          </h4>
          <p class="text-muted mb-0 small">Theo dõi sức khỏe đội xe tải & xe cẩu</p>
        </div>
        <button class="btn btn-primary shadow-sm font-weight-bold" @click="openCreateModal">
          <i class="fa fa-plus-circle mr-1"></i> Tạo Phiếu Mới
        </button>
      </div>

      <div class="row mb-4">
        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-danger">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-uppercase text-muted font-weight-bold" style="font-size: 0.7rem;">Sự cố / SOS</small>
                  <h2 class="mb-0 text-danger font-weight-bold">{{ stats.critical }}</h2>
                </div>
                <div class="icon-circle bg-light-danger text-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-warning">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-uppercase text-muted font-weight-bold" style="font-size: 0.7rem;">Đang sửa chữa</small>
                  <h2 class="mb-0 text-warning font-weight-bold">{{ stats.repairing }}</h2>
                </div>
                <div class="icon-circle bg-light-warning text-warning">
                  <i class="fa fa-tools"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-info">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-uppercase text-muted font-weight-bold" style="font-size: 0.7rem;">Chờ thanh toán</small>
                  <h2 class="mb-0 text-info font-weight-bold">{{ stats.payment }}</h2>
                </div>
                <div class="icon-circle bg-light-info text-info">
                  <i class="fa fa-file-invoice-dollar"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2">
          <div class="card border-0 shadow-sm h-100 kpi-card border-left-success">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small class="text-uppercase text-muted font-weight-bold" style="font-size: 0.7rem;">Chi phí (Tháng)</small>
                  <h5 class="mb-0 text-success font-weight-bold">{{ formatCurrency(stats.costMonth) }}</h5>
                </div>
                <div class="icon-circle bg-light-success text-success">
                  <i class="fa fa-coins"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0 shadow-sm">
        <div class="card-header bg-white border-bottom-0 py-3">
          <div class="d-flex flex-wrap align-items-center gap-2 justify-content-between">
            <ul class="nav nav-pills filter-pills">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: filterStatus === null }" href="#" @click.prevent="filterStatus = null">Tất cả</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: filterStatus === 'MOI' }" href="#" @click.prevent="filterStatus = 'MOI'">Mới</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: filterStatus === 'DANG_SUA' }" href="#" @click.prevent="filterStatus = 'DANG_SUA'">Đang sửa</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: filterStatus === 'HOAN_THANH' }" href="#" @click.prevent="filterStatus = 'HOAN_THANH'">Hoàn thành</a>
              </li>
            </ul>

            <div class="input-group" style="max-width: 250px;">
              <div class="input-group-prepend">
                <span class="input-group-text bg-light border-right-0"><i class="fa fa-search text-muted"></i></span>
              </div>
              <input type="text" class="form-control border-left-0 bg-light" placeholder="Tìm biển số, lỗi..." v-model="searchQuery">
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0 custom-table">
            <thead class="bg-light">
              <tr class="text-uppercase text-muted small font-weight-bold">
                <th class="pl-4 border-0">Phương tiện</th>
                <th class="border-0">Vấn đề / Hạng mục</th>
                <th class="border-0">Trạng thái</th>
                <th class="border-0">Chi phí</th>
                <th class="border-0">Người tạo</th>
                <th class="text-right pr-4 border-0">Tác vụ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredList" :key="item.id" class="cursor-pointer" @click="openDetail(item)">
                <td class="pl-4">
                  <div class="d-flex align-items-center">
                    <div class="vehicle-icon mr-3" :class="item.xeLoai === 'CAU' ? 'bg-warning-soft' : 'bg-primary-soft'">
                      <i class="fa" :class="item.xeLoai === 'CAU' ? 'fa-truck-loading' : 'fa-truck'"></i>
                    </div>
                    <div>
                      <div class="font-weight-bold text-dark">{{ item.xeBienSo }}</div>
                      <small class="text-muted">{{ item.xeLoai }}</small>
                    </div>
                  </div>
                </td>

                <td>
                  <span class="badge mb-1" :class="getLoaiBadge(item.loaiBaoDuong)">{{ item.loaiBaoDuong }}</span>
                  <div class="text-truncate font-weight-500" style="max-width: 280px;">{{ item.noiDung }}</div>
                  <small class="text-muted" v-if="item.huongXuLy">
                    <i class="fa fa-arrow-right mr-1"></i>{{ getHuongXuLyLabel(item.huongXuLy) }}
                  </small>
                </td>

                <td>
                  <div class="d-flex align-items-center">
                    <span class="status-dot mr-2" :class="getStatusColor(item.trangThai)"></span>
                    <span class="font-weight-bold small text-dark">{{ getTrangThaiLabel(item.trangThai) }}</span>
                  </div>
                </td>

                <td>
                  <div v-if="item.chiPhiThucTe" class="font-weight-bold text-dark">{{ formatCurrency(item.chiPhiThucTe) }}</div>
                  <div v-else-if="item.giaDuocDuyet" class="text-success small">~{{ formatCurrency(item.giaDuocDuyet) }} (Duyệt)</div>
                  <div v-else class="text-muted">-</div>
                </td>

                <td>
                   <div class="small">{{ item.nguoiTao }}</div>
                   <small class="text-muted">{{ formatDate(item.ngayTao) }}</small>
                </td>

                <td class="text-right pr-4">
                  <button class="btn btn-sm btn-light text-primary hover-scale">
                    <i class="fa fa-angle-right"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          
          <div v-if="filteredList.length === 0" class="text-center py-5 text-muted">
             <i class="fa fa-folder-open fa-3x mb-3 text-light-gray"></i>
             <p>Không tìm thấy phiếu nào phù hợp.</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal-backdrop-custom">
      <div class="custom-modal shadow-lg animate-slide-up">
        
        <div class="modal-header d-flex justify-content-between align-items-start bg-white border-bottom-0 pb-0">
          <div>
            <h5 class="font-weight-bold mb-1">
              {{ isCreateMode ? 'Tạo Yêu Cầu Sửa Chữa Mới' : `#${selectedTicket.id} - ${selectedTicket.xeBienSo}` }}
            </h5>
            <div v-if="!isCreateMode" class="d-flex align-items-center gap-2">
               <span class="badge badge-pill px-3 py-1" :class="getStatusBadgeClass(selectedTicket.trangThai)">
                 {{ getTrangThaiLabel(selectedTicket.trangThai) }}
               </span>
               <span class="text-muted small"><i class="fa fa-clock mr-1"></i>{{ formatDate(selectedTicket.ngayTao) }}</span>
            </div>
          </div>
          <button class="btn btn-sm btn-light rounded-circle" @click="closeModal"><i class="fa fa-times"></i></button>
        </div>

        <div class="modal-body row pt-3">
          
          <div class="col-lg-7 border-right pr-lg-4 scrollable-col">
            <h6 class="text-uppercase text-muted small font-weight-bold mb-3 border-bottom pb-2">Thông tin kỹ thuật</h6>
            
            <div class="form-row">
               <div class="col-md-6 form-group">
                 <label class="small font-weight-bold text-dark">Phương tiện</label>
                 <select v-if="isCreateMode" v-model="form.xeId" class="form-control custom-input">
                    <option :value="null">-- Chọn xe --</option>
                    <option v-for="xe in mockVehicles" :key="xe.id" :value="xe.id">{{ xe.bienSo }} ({{ xe.loai }})</option>
                 </select>
                 <input v-else type="text" class="form-control-plaintext font-weight-bold" :value="selectedTicket.xeBienSo" readonly>
               </div>
               <div class="col-md-6 form-group">
                 <label class="small font-weight-bold text-dark">Số ODO / Giờ máy</label>
                 <input type="number" class="form-control custom-input" v-model="form.odo" placeholder="Nhập số km...">
               </div>
            </div>

            <div class="form-group">
               <label class="small font-weight-bold text-dark">Nội dung sự cố / Hạng mục</label>
               <textarea class="form-control custom-input" rows="3" v-model="form.noiDung" placeholder="Mô tả chi tiết hư hỏng..."></textarea>
            </div>

            <div class="form-group">
               <label class="small font-weight-bold text-dark">Hình ảnh hiện trường</label>
               <div class="d-flex gap-2 align-items-center">
                  <div class="img-preview rounded bg-light d-flex align-items-center justify-content-center text-muted border-dashed" 
                       style="width: 80px; height: 80px; cursor: pointer;">
                     <i class="fa fa-camera fa-lg"></i>
                  </div>
                  <span class="text-muted small font-italic ml-2">Chưa có ảnh nào được tải lên.</span>
               </div>
            </div>

            <div v-if="!isCreateMode">
               <h6 class="text-uppercase text-muted small font-weight-bold mb-3 mt-4 border-bottom pb-2">Lịch sử sửa chữa gần nhất</h6>
               <div class="alert alert-light border small text-muted">
                 <i class="fa fa-info-circle mr-1"></i> Xe này vừa thay nhớt cách đây 10 ngày (15/05/2024).
               </div>
            </div>
          </div>

          <div class="col-lg-5 pl-lg-4 d-flex flex-column h-100">
             
             <div class="card bg-light-primary border-0 mb-3" v-if="!isCreateMode">
                <div class="card-body p-3">
                   <h6 class="font-weight-bold text-primary mb-2">Hướng giải quyết</h6>
                   <div class="btn-group w-100 mb-2">
                      <button class="btn btn-sm btn-white border shadow-sm" :class="{active: form.huongXuLy === 'MUA_PHU_TUNG'}" @click="form.huongXuLy = 'MUA_PHU_TUNG'">🛠️ Tự sửa</button>
                      <button class="btn btn-sm btn-white border shadow-sm" :class="{active: form.huongXuLy === 'RA_GARA'}" @click="form.huongXuLy = 'RA_GARA'">🏭 Ra Gara</button>
                   </div>
                   
                   <div v-if="form.huongXuLy === 'RA_GARA'" class="mb-2">
                      <input type="text" class="form-control form-control-sm" placeholder="Tên Gara đề xuất..." v-model="form.garaDeXuat">
                   </div>

                   <button v-if="selectedTicket.trangThai === 'MOI'" class="btn btn-primary btn-block btn-sm font-weight-bold" @click="changeStatus('DANG_SUA')">
                      Duyệt & Tiến hành
                   </button>
                   <button v-if="selectedTicket.trangThai === 'DANG_SUA'" class="btn btn-success btn-block btn-sm font-weight-bold" @click="changeStatus('CHO_THANH_TOAN')">
                      Xác nhận Hoàn thành
                   </button>
                   <button v-if="selectedTicket.trangThai === 'CHO_THANH_TOAN'" class="btn btn-secondary btn-block btn-sm font-weight-bold" @click="changeStatus('HOAN_THANH')">
                      Đã Thanh toán
                   </button>
                </div>
             </div>

             <div class="flex-grow-1 d-flex flex-column border rounded bg-white overflow-hidden" v-if="!isCreateMode">
                <div class="bg-light p-2 border-bottom small font-weight-bold text-muted">Trao đổi nội bộ</div>
                <div class="flex-grow-1 p-3 scrollable-chat" style="height: 200px; overflow-y: auto;">
                   <div class="chat-msg left">
                      <div class="bubble">Xe đang nằm đường, cần cứu hộ gấp anh ơi!</div>
                      <div class="meta">Tài xế - 10:30</div>
                   </div>
                   <div class="chat-msg right">
                      <div class="bubble">Đã nhận tin. Đang điều gara gần nhất ra.</div>
                      <div class="meta">Admin - 10:35</div>
                   </div>
                </div>
                <div class="p-2 border-top bg-light">
                   <div class="input-group input-group-sm">
                      <input type="text" class="form-control border-0" placeholder="Nhập tin nhắn...">
                      <div class="input-group-append">
                         <button class="btn btn-primary"><i class="fa fa-paper-plane"></i></button>
                      </div>
                   </div>
                </div>
             </div>

          </div>
        </div>

        <div class="modal-footer bg-light border-top-0 py-2">
          <button v-if="isCreateMode" class="btn btn-primary px-4 shadow-sm" @click="createTicket">Lưu Phiếu Mới</button>
          <button class="btn btn-outline-secondary px-4" @click="closeModal">Đóng</button>
        </div>

      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';

// --- 1. MOCK DATA (Dữ liệu giả lập) ---
const mockVehicles = [
  { id: 1, bienSo: '61C-123.45', loai: 'TAI' },
  { id: 2, bienSo: '61C-999.99', loai: 'TAI' },
  { id: 3, bienSo: 'CAU-50T-01', loai: 'CAU' },
];

const mockTickets = [
  { id: 101, xeId: 1, xeBienSo: '61C-123.45', xeLoai: 'TAI', loaiBaoDuong: 'SU_CO', noiDung: 'Bể ống thủy lực, xì nhớt', trangThai: 'MOI', chiPhiThucTe: null, giaDuocDuyet: null, nguoiTao: 'Nguyễn Văn A', ngayTao: '2025-05-20T10:30:00', huongXuLy: null },
  { id: 102, xeId: 3, xeBienSo: 'CAU-50T-01', xeLoai: 'CAU', loaiBaoDuong: 'DINH_KY', noiDung: 'Bảo dưỡng định kỳ mức 500h', trangThai: 'DANG_SUA', chiPhiThucTe: null, giaDuocDuyet: 2500000, nguoiTao: 'Hệ thống', ngayTao: '2025-05-19T08:00:00', huongXuLy: 'MUA_PHU_TUNG' },
  { id: 103, xeId: 2, xeBienSo: '61C-999.99', xeLoai: 'TAI', loaiBaoDuong: 'SU_CO', noiDung: 'Thay lốp sau bên phải', trangThai: 'CHO_THANH_TOAN', chiPhiThucTe: 4500000, giaDuocDuyet: 4500000, nguoiTao: 'Trần Văn B', ngayTao: '2025-05-18T14:20:00', huongXuLy: 'RA_GARA' },
  { id: 104, xeId: 1, xeBienSo: '61C-123.45', xeLoai: 'TAI', loaiBaoDuong: 'SU_CO', noiDung: 'Hỏng đèn xi nhan', trangThai: 'HOAN_THANH', chiPhiThucTe: 150000, giaDuocDuyet: 150000, nguoiTao: 'Nguyễn Văn A', ngayTao: '2025-05-10T09:00:00', huongXuLy: 'MUA_PHU_TUNG' },
];

// --- 2. STATE ---
const tickets = ref([...mockTickets]);
const filterStatus = ref(null);
const searchQuery = ref('');
const showModal = ref(false);
const isCreateMode = ref(false);
const selectedTicket = ref({});
const form = reactive({
    xeId: null,
    odo: null,
    noiDung: '',
    huongXuLy: null,
    garaDeXuat: ''
});

// --- 3. COMPUTED LOGIC ---
const filteredList = computed(() => {
    return tickets.value.filter(t => {
        const matchStatus = filterStatus.value ? t.trangThai === filterStatus.value : true;
        const q = searchQuery.value.toLowerCase();
        const matchSearch = t.xeBienSo.toLowerCase().includes(q) || t.noiDung.toLowerCase().includes(q);
        return matchStatus && matchSearch;
    });
});

const stats = computed(() => ({
    critical: tickets.value.filter(t => t.trangThai === 'MOI').length,
    repairing: tickets.value.filter(t => t.trangThai === 'DANG_SUA').length,
    payment: tickets.value.filter(t => t.trangThai === 'CHO_THANH_TOAN').length,
    costMonth: tickets.value.reduce((acc, curr) => acc + (curr.chiPhiThucTe || 0), 0)
}));

// --- 4. ACTIONS ---
const openCreateModal = () => {
    isCreateMode.value = true;
    Object.assign(form, { xeId: null, odo: null, noiDung: '', huongXuLy: null, garaDeXuat: '' });
    showModal.value = true;
};

const openDetail = (item) => {
    isCreateMode.value = false;
    selectedTicket.value = { ...item };
    Object.assign(form, {
        xeId: item.xeId,
        odo: 0,
        noiDung: item.noiDung,
        huongXuLy: item.huongXuLy,
        garaDeXuat: ''
    });
    showModal.value = true;
};

const closeModal = () => {
    showModal.value = false;
};

const createTicket = () => {
    if (!form.xeId || !form.noiDung) return alert('Vui lòng nhập đủ thông tin');
    const xe = mockVehicles.find(x => x.id === form.xeId);
    const newTicket = {
        id: Math.floor(Math.random() * 1000),
        xeId: form.xeId,
        xeBienSo: xe.bienSo,
        xeLoai: xe.loai,
        loaiBaoDuong: 'SU_CO',
        noiDung: form.noiDung,
        trangThai: 'MOI',
        nguoiTao: 'Admin',
        ngayTao: new Date().toISOString()
    };
    tickets.value.unshift(newTicket);
    closeModal();
};

const changeStatus = (newStatus) => {
    // Cập nhật local list
    const idx = tickets.value.findIndex(t => t.id === selectedTicket.value.id);
    if (idx !== -1) {
        tickets.value[idx].trangThai = newStatus;
        tickets.value[idx].huongXuLy = form.huongXuLy; // Save hướng xử lý
        selectedTicket.value.trangThai = newStatus; // Update modal view UI
    }
};

// --- 5. HELPERS ---
const formatCurrency = (val) => val ? new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(val) : '0 ₫';
const formatDate = (dateStr) => {
    if(!dateStr) return '';
    const d = new Date(dateStr);
    return `${d.getDate()}/${d.getMonth()+1} ${d.getHours()}:${d.getMinutes()}`;
}

const getLoaiBadge = (loai) => loai === 'SU_CO' ? 'badge-danger' : 'badge-info';
const getTrangThaiLabel = (st) => ({ MOI: 'Mới tạo', DANG_SUA: 'Đang sửa', CHO_THANH_TOAN: 'Chờ thanh toán', HOAN_THANH: 'Hoàn thành' }[st] || st);
const getStatusColor = (st) => ({ MOI: 'bg-danger', DANG_SUA: 'bg-warning', CHO_THANH_TOAN: 'bg-info', HOAN_THANH: 'bg-success' }[st]);
const getStatusBadgeClass = (st) => ({ MOI: 'badge-danger', DANG_SUA: 'badge-warning', CHO_THANH_TOAN: 'badge-info', HOAN_THANH: 'badge-success' }[st]);
const getHuongXuLyLabel = (h) => h === 'RA_GARA' ? 'Ra Gara' : (h === 'MUA_PHU_TUNG' ? 'Tự sửa' : '');

</script>

<style scoped>
/* ================= CSS TINH CHỈNH GIAO DIỆN ================= */
.font-inter { font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }

/* KPI Cards */
.kpi-card { border-left-width: 4px !important; transition: transform 0.2s; }
.kpi-card:hover { transform: translateY(-3px); }
.border-left-danger { border-left-color: #dc3545 !important; }
.border-left-warning { border-left-color: #ffc107 !important; }
.border-left-info { border-left-color: #17a2b8 !important; }
.border-left-success { border-left-color: #28a745 !important; }

.icon-circle { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; }
.bg-light-danger { background-color: rgba(220, 53, 69, 0.1); }
.bg-light-warning { background-color: rgba(255, 193, 7, 0.1); }
.bg-light-info { background-color: rgba(23, 162, 184, 0.1); }
.bg-light-success { background-color: rgba(40, 167, 69, 0.1); }

/* Table */
.custom-table th { font-size: 0.75rem; letter-spacing: 0.5px; }
.vehicle-icon { width: 36px; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1rem; }
.bg-primary-soft { background-color: #e3f2fd; color: #007bff; }
.bg-warning-soft { background-color: #fff3cd; color: #856404; }
.status-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }
.hover-scale:hover { transform: scale(1.1); }
.cursor-pointer { cursor: pointer; }

/* Filter Pills */
.filter-pills .nav-link { border-radius: 20px; padding: 6px 16px; color: #6c757d; font-size: 0.9rem; font-weight: 500; }
.filter-pills .nav-link.active { background-color: #343a40; color: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.2); }

/* Custom Modal */
.modal-backdrop-custom { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1050; display: flex; justify-content: center; align-items: center; }
.custom-modal { background: #fff; width: 90%; max-width: 1000px; height: 85vh; border-radius: 8px; display: flex; flex-direction: column; overflow: hidden; }
.animate-slide-up { animation: slideUp 0.3s ease-out; }
@keyframes slideUp { from { transform: translateY(50px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

.custom-input { background-color: #f8f9fa; border: 1px solid #e9ecef; }
.custom-input:focus { background-color: #fff; border-color: #80bdff; box-shadow: none; }
.border-dashed { border: 2px dashed #dee2e6; }
.scrollable-col { overflow-y: auto; max-height: calc(85vh - 120px); }

/* Chat Bubble UI */
.chat-msg { margin-bottom: 10px; display: flex; flex-direction: column; }
.chat-msg.left { align-items: flex-start; }
.chat-msg.right { align-items: flex-end; }
.chat-msg .bubble { padding: 8px 12px; border-radius: 12px; font-size: 0.9rem; max-width: 80%; }
.chat-msg.left .bubble { background: #f1f3f5; color: #333; border-bottom-left-radius: 2px; }
.chat-msg.right .bubble { background: #007bff; color: #fff; border-bottom-right-radius: 2px; }
.chat-msg .meta { font-size: 0.65rem; color: #999; margin-top: 2px; }

/* Responsive adjustments */
@media (max-width: 768px) {
    .kpi-card { margin-bottom: 10px; }
    .custom-modal { width: 100%; height: 100%; border-radius: 0; }
    .modal-body { flex-direction: column; }
    .col-lg-7 { border-right: none !important; border-bottom: 1px solid #eee; margin-bottom: 1rem; }
}
</style>